import { User as Profile } from '@auth0/auth0-spa-js';

import type { VdoUser } from './vdo-user.d';
// import { log } from '../log';

import { VdoApiUser, VdoApiUserV2 } from './vdo-user.model';

// const logger = log.getLogger('shell:user');

declare namespace Intl {
  //https://github.com/Microsoft/TypeScript/issues/29129
  //only available in TS 4.7
  function getCanonicalLocales(locales: string | string[]): string[];
}

type CleanUser = Omit<
  VdoUser,
  'userName' | 'language' | 'timeZoneId' | 'userEmail' | 'accountID' | 'accountName' | 'userID' | 'spId'
>;
export function mapUser(user: VdoApiUserV2, profile?: Profile): VdoUser {
  let u: CleanUser = {
    account_id: +user.account.id,
    account_name: user.account.displayName,
    // user_id: user.UserID,
    id: +user.vdoUserId,
    sp_id: `${user.account.solutionProviderId}`, //user.spId,
    // not need to keep all vdo permissions
    permissions: user.grants.permissions.filter(
      item => (item.startsWith('maps:') && !item.endsWith(':update:assets')) || item == 'maps'
    ),
    // assignedPackages: user.assignedPackages?.map(p => p.packageName), // check with olivier
    // assignedUserLevels: user.assignedUserLevels?.map(l => l.userLevelName),// check with olivier
    email: user.user.email,
    locale: user.user.preferences.locale,
    zoneinfo: user.account.timezone,
    name: user.user.displayName,
    sub: `tisAdmin|${user.vdoUserId}`,

    identityProviderId: `${user.account.solutionProviderId}`
  };
  if (profile) {
    u = { ...u, ...profile };
    //Use prefered name, fallback to "first_name family_name"
    u.preferred_username =
      u.preferred_username ?? u.name ?? `${u.nickname ?? u.given_name ?? ''} ${u.family_name ?? ''}`;

    u.firstName = u.given_name ?? '';
    u.lastName = u.family_name ?? '';
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    Intl.getCanonicalLocales(u.locale?.replace('_', '-') || 'en-GB');
  } catch (err) {
    //prevent invalid locale setup. fallback to english if it does not look like a locale
    u.locale = 'en-GB';
  }

  //compat mode
  return Object.freeze(compatMode(u)) as VdoUser;
}

function compatMode(user: CleanUser) {
  const compatAliases = new Map<string, string>();
  compatAliases.set('userName', 'name');
  compatAliases.set('language', 'locale');
  compatAliases.set('timeZoneId', 'zoneinfo');
  compatAliases.set('userEmail', 'email');
  compatAliases.set('accountID', 'account_id');
  compatAliases.set('accountName', 'account_name');
  compatAliases.set('userID', 'user_id');
  compatAliases.set('spId', 'sp_id');
  compatAliases.forEach((source, alias) => {
    Object.defineProperty(user, alias, {
      get() {
        // logger.warn(`deprecation: use of deprecated field on User: ${alias}`);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        return this[source];
      }
    });
  });
  return user;
}
